import createRepository from './generic';

export default () => createRepository('cache');
